import { memo } from "react";
import styled from "styled-components";

const featureArrow = "./assets/icon/images/right-arrow.svg";

interface Feature {
  title: string;
  description: string;
  icon: string;
  background: string;
}

interface CardComponentProps {
  feature?: Feature;
  index?: number;
}

const CardComponent = memo(
  ({
    feature = {
      title: "Default Title",
      description: "Default Description",
      icon: "default-icon.png",
      background: "#f0f0f0"
    },
    index = 0
  }: CardComponentProps) => {
    return (
      <FeatureCard key={index} style={{ background: feature.background }}>
        <FeatureIconsRow>
          <FeatureIcon src={feature.icon} alt={feature.title} />
          <FeatureArrow src={featureArrow} alt={"Go"} />
        </FeatureIconsRow>
        <Title>{feature.title}</Title>
        <Description>{feature.description}</Description>
      </FeatureCard>
    );
  }
);

const FeatureCard = styled.div`
  flex: 1;
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  padding: 64px;
  min-width: 300px;

  @media (max-width: 1025px) {
    width: fit-content;
    padding: 40px 28px;
    min-width: unset;
  }

  @media (max-width: 767px) {
    min-width: unset;
  }
`;

const FeatureIconsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 767px) {
    flex-direction: row;
  }
`;

const FeatureIcon = styled.img`
  width: 80px;
  height: auto;
`;

const FeatureArrow = styled.img`
  width: 48px;
  height: 48px;

  @media (max-width: 767px) {
    margin-top: 0px;
  }
`;

const Title = styled.p`
  font-size: 2em;
  font-weight: 600;
  color: black;

  @media (max-width: 1025px) {
    font-size: 1.5em;
  }

  @media (max-width: 767px) {
    line-height: 1.2;
    margin-top: 32px;
  }
`;

const Description = styled.p`
  font-size: 1.1em;
  line-height: 1.5;
  color: #33415c;
  font-weight: 500;

  @media (max-width: 1025px) {
    font-size: 1em;
  }
`;

export default memo(CardComponent);
